import { useDispatch } from 'react-redux';

import { pushSiteNotification } from 'containers/App/actions';

export const usePushSiteNotification = () => {
  const dispatch = useDispatch();
  return (message, time = 3000) => dispatch(pushSiteNotification({ message, time }));
};
